import React, { PropsWithChildren, createContext, useContext } from "react";
import { Bundle } from "./types";

type BundleContextState = { bundle: Bundle };

export const BundleContext = createContext<BundleContextState | undefined>(
  undefined
);

export const useBundleContext = () => {
  const context = useContext(BundleContext);
  if (context === undefined) {
    throw new Error("useBundleContext must be used within a BundleProvider");
  }
  return context;
};

export const BundleProvider = (
  props: PropsWithChildren<BundleContextState>
) => {
  const { children, ...rest } = props;
  return (
    <BundleContext.Provider value={rest}>{children}</BundleContext.Provider>
  );
};
